import { isPlainObject, pick } from 'lodash'
import QueryString from 'qs'
import { apiClient } from '../client'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { PageListParams } from '../globalTypes'
import { PROJECT_VALUE_ENDPOINTS } from './formValuesConfig'
import { ProjectCriteria, ProjectParams, ProjectPayload, ProjectValuesData } from './types'

export const getProjectById = async (id: number, params: ProjectParams = {}) => {
    const response = await apiClient(`v1/project/${id}`, {
        params,
        paramsSerializer: (params: ProjectParams) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
    })
    return response.data
}

export const getProjects = async (params: PageListParams<ProjectCriteria>) => {
    const response = await apiClient('v1/project', {
        params,
        paramsSerializer: (params: PageListParams<ProjectCriteria>) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
    })
    return response.data
}

export const createUpdateProject = async (payload: ProjectPayload) => {
    const { isEdit, data } = payload
    const url = isEdit && 'id' in data ? `v1/project/${data.id}` : 'v1/project'

    const response = await apiClient(url, {
        method: isEdit ? 'PUT' : 'POST',
        data: data,
    })
    return response.data
}

export const deleteProjectById = async (id: number) => {
    const response = await apiClient(`v1/project/${id}`, {
        method: 'DELETE',
    })

    return response.data
}

export const deleteProjects = async (ids: number[]) => {
    const response = await apiClient('v1/project', {
        method: 'DELETE',
        data: {
            ids,
        },
    })

    return response.data
}

export const fetchProjectValues = (fields?: string[]) => {
    const endpoints = fields ? pick(PROJECT_VALUE_ENDPOINTS, fields) : PROJECT_VALUE_ENDPOINTS

    return fetchFormValues<ProjectValuesData>(endpoints)
}
